import { GameManual } from '../../types';

export const laFamigliaLegacyManualStub: GameManual = {
  chapters: [],
  firstGameSteps: [],
};
